import React, { ReactElement, useEffect, useState } from 'react';
import { useHistory, generatePath } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { injectIntl } from 'react-intl';
import { Card } from 'antd';
import {
  getPaciente, getPacientesTiendas,
} from '../../../../state/actions/creators/pacientes.actioncreator';
import { ROUTE_PACIENTES_FILE } from '../../../../routes.constants';
import TablePatientList from './tablePatientList';
import Page from '../../../shared/components/layout/Page.layout';
import { Text } from '../../../shared/components';
import FullPage from '../../../shared/components/layout/FullPage.layout';


function PatientList({ intl }: any) {
  const history = useHistory();
  const dispatch = useDispatch();
  const tiendaId = useSelector((state: any) => state.auth.user.user_info.tienda_id);

  const rowClick = (pacient: any) => {
    //dispatch(getPaciente({ tiendaId, pacienteId: pacient.id }));
    sessionStorage.removeItem('infoPacienteIdSeleccionado');
    history.push(generatePath(ROUTE_PACIENTES_FILE, { pacienteId: pacient.id }));
  };

  const clientList: ReactElement = (
    <TablePatientList rowClick={rowClick} pageSize={20} />
  );

  return (
    <FullPage
      tituloTraduccionId="navegacion.pacientes.buscar_clientes"
      navigationItems={[
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.home" />,
          link: '',
        },
        {
          node: <Text children="" upperCase={false} lowerCase={false} translationId="navegacion.pacientes" />,
        },
      ]}
    >
      <Card
        title={null}
      >
        <div className="patient-list">
          {clientList}
        </div>
      </Card>
    </FullPage>
  );
}

export default injectIntl(PatientList);
